import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ image, name, price, sizes }) => {
  const navigate = useNavigate();
  const [selectedSize, setSelectedSize] = useState('');
  const [sizeError, setSizeError] = useState(false);

  const sizeList = sizes ? sizes.split(',').map(s => s.trim()).filter(Boolean) : [];
  const hasSize = sizeList.length > 0;

  const handleBuy = () => {
    if (hasSize && !selectedSize) {
      setSizeError(true);
      return;
    }
    setSizeError(false);
    const numericPrice = Math.round(parseFloat(price.replace(/[^0-9.]/g, '').replace(/,/g, '')));
    const params = new URLSearchParams({
      product: name,
      amount: numericPrice,
      display_price: price,
      ...(selectedSize && { size: selectedSize }),
    });
    navigate(`/checkout?${params.toString()}`);
  };

  return (
    <div className="product-card">
      <img src={image} alt={name} className="product-image" />
      <div className="product-info">
        <h3 className="product-name">{name}</h3>
        <p className="product-price">{price}</p>

        {hasSize && (
          <div className={`size-selector ${sizeError ? 'size-error' : ''}`}>
            <p className="size-label">Select Size</p>
            <div className="size-options">
              {sizeList.map(s => (
                <button
                  key={s}
                  className={`size-btn ${selectedSize === s ? 'active' : ''}`}
                  onClick={() => { setSelectedSize(s); setSizeError(false); }}
                >
                  {s}
                </button>
              ))}
            </div>
            {sizeError && <p className="size-error-msg">Please select a size</p>}
          </div>
        )}

        <button className="product-buy" onClick={handleBuy}>Buy Now</button>
      </div>
    </div>
  );
};

export default ProductCard;
